import {Store} from '../classes/store';
import {Injectable, Inject} from '@angular/core';
import { ConvertResourceToJsonPipe } from '../../convert-resource-to-json/convert-resource-to-json.pipe';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserStore extends Store<User | any> {

  /** Legacy User reference. */
  private sgUserService: any;

  /** Constructor. */
  constructor(
    @Inject('sgUser') sgUserService: any,
    private convertResourceToJon: ConvertResourceToJsonPipe
  ) {
    super();
    this.sgUserService = sgUserService;
    this._populateWithTenantUsers();
  }

  /**
   * Populate the user list with the (remaining) tenant users.
   *
   * To prevent an infinte loop because the observable is updating itself, check if the
   * user list is different from the previous list. Now it's still able to update after
   * adding or editting a user, or after changing project.
   *
   * Project users can be filtered by checking the `user.project` property.
   */
  private _populateWithTenantUsers(): void {
    this.state$.pipe(
      distinctUntilChanged((previous, next) => JSON.stringify(previous) === JSON.stringify(next))
    ).subscribe(users => {
      if (!users.length) {
        return;
      }
      this.sgUserService.query({ currentTenant: true }).$promise.then(response => {
        for (const user of this.convertResourceToJon.transform(response)) {
          if (users.findIndex(x => x._id === user._id) === -1) {
            users.push({ ...user, project: false });
          }
        }
        this.setState(users);
      });
    });
  }

}
